import React from 'react';
import Image from 'next/legacy/image';

import finance from '../../public/images/finance.svg';
import PopUpContactUs from 'components/ContactUs/PopUpContactUs';

// 2px dash / 2px gap, as in the design; CSS dashed borders can't set dash length
const dashedUnderline: React.CSSProperties = {
  backgroundImage: 'linear-gradient(to right, #878787 2px, transparent 2px)',
  backgroundSize: '4px 1px',
  backgroundPosition: 'bottom',
  backgroundRepeat: 'repeat-x',
};

type FinancingSectionProps = {
  buildingName: string;
  lowestDownPayment?: number | null;
  className?: string;
};

const FinancingSection: React.FC<FinancingSectionProps> = ({
  buildingName,
  lowestDownPayment,
  className = '',
}) => {
  // API returns null for excluded neighborhoods and buildings without recent deals
  if (lowestDownPayment == null) return null;

  const percent = `${lowestDownPayment}%`;

  return (
    <section
      className={`bg-gold-backgroundV2 border-t border-b border-gold px-5 md:px-10 py-5 md:py-10 xl:py-[50px] ${className}`}
    >
      <div className="max-w-[900px] mx-auto">
        <h2
          style={dashedUnderline}
          className="inline-block pb-[15px] md:py-[9px] font-sohneBreitHalbfett uppercase text-[20px] md:text-[22px] leading-[23px] tracking-[0.2px] md:tracking-[0.22px]"
        >
          Financing for {buildingName}
        </h2>
        {/* Mobile: contact line spans under icon + text; md+: it sits in the text column */}
        <div className="grid grid-cols-[71px,1fr] md:grid-cols-[150px,1fr] gap-x-[15px] md:gap-x-[30px] gap-y-[30px] mt-5 md:mt-[35px]">
          <div className="relative self-center w-[71px] h-[71px] md:w-[150px] md:h-[150px] md:row-span-2">
            <Image src={finance} alt="" layout="fill" />
          </div>
          <div className="self-center md:self-end">
            <p className="font-sohneKraftig text-[16px] leading-[23px] md:hidden">
              {percent} was the lowest down payment in 6 months.
            </p>
            <p className="hidden md:block lgx:max-w-[600px] font-sohneKraftig text-[22px] leading-[34px]">
              In the past 6 months, {percent} was the lowest down payment made
              for a purchase in {buildingName}.
            </p>
          </div>
          <div className="col-span-2 md:col-span-1 md:col-start-2 md:self-start font-sohneBuch text-[16px] md:text-[18px] leading-[23px] md:leading-[34px]">
            <PopUpContactUs
              contactUsNotButton="CONTACT US"
              contactUsNotButtonClassName="font-sohneKraftig underline"
              customText={`I'm interested in learning more about financing options at ${buildingName}.`}
            />{' '}
            for more financing information or to get pre-approved.
          </div>
        </div>
      </div>
    </section>
  );
};

export default FinancingSection;
